import React from 'react';
import { Container } from '@mui/material';
import RomaneioConferenciaEditar from '../components/romaneio/RomaneioConferenciaEditar';

const RomaneioConferenciaEditarPage: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <RomaneioConferenciaEditar />
    </Container>
  );
};

export default RomaneioConferenciaEditarPage;
